import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export const useAbortImport = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, void> = async () => {
		return http({
			method: "POST",
			url: "/import/abort",
			body: undefined
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["importStatus"] });
		}
	});
};
